import { render, staticRenderFns } from "./MaterialModal.vue?vue&type=template&id=74e0291c"
import script from "./MaterialModal.vue?vue&type=script&lang=js"
export * from "./MaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports